import { toast } from "react-toastify"

import { REQ } from "constants/api/requests"
import { IResponse } from "constants/interfaces"
import { DEFAULT_LOCALE } from "constants/languages"
import { TableHandler } from "constants/type"

import useApi from "util/api"

import { PromotionDetail, PromotionListItem, PromotionPayload, PromotionsTableFilters, PromotionsTableResponse } from "./type"

class PromotionsService {
  public getPromotionsTable: TableHandler = async (
    page: number,
    pageSize: number,
    _id: number | undefined,
    { q, createdAt, status, category, includeInactive, locale }: PromotionsTableFilters,
    sortRow?: string,
    sortOrder?: string
  ): Promise<PromotionsTableResponse | void> => {
    try {
      const params = {
        page,
        pageSize,

        // filters
        query: q?.trim() || null,
        createdAt: createdAt || null,
        status: status || null,
        category: category || null,
        includeInactive: includeInactive ?? false,
        locale: locale || DEFAULT_LOCALE,

        // sorting
        sortRow: sortRow || "created_at",
        sortOrder: (sortOrder as "asc" | "desc") || "desc"
      }

      const { data } = await useApi.get<IResponse<PromotionsTableResponse>>(REQ.ADMIN_DASHBOARD.PROMOTIONS.LIST, { params })

      if (data?.success) {
        return data.response
      }
    } catch (err: any) {
      toast.error(err?.message ?? err?.data?.message ?? "Failed to get promotions")
    }
  }

  async getPromotionById(id: string): Promise<PromotionDetail> {
    const { data } = await useApi.get<IResponse<PromotionDetail>>(REQ.ADMIN_DASHBOARD.PROMOTIONS.DETAIL(id))
    return data.response
  }

  async createPromotion(payload: PromotionPayload) {
    const response = await useApi.post<{ data: PromotionListItem }>(REQ.ADMIN_DASHBOARD.PROMOTIONS.LIST, payload)
    return response.data.data
  }

  async updatePromotion(id: string, payload: Partial<PromotionPayload>) {
    const response = await useApi.patch<{ data: PromotionListItem }>(REQ.ADMIN_DASHBOARD.PROMOTIONS.DETAIL(id), payload)
    return response.data.data
  }

  async deletePromotion(id: string) {
    await useApi.delete(REQ.ADMIN_DASHBOARD.PROMOTIONS.DETAIL(id))
  }
}

export const promotionsService = new PromotionsService()
